module.exports = __webpack_public_path__ + "static/media/Darth Vader.237e166f.jpg";